import React from "react";
  import API from "../../services/api";


function PopupImageBlock({block, updateBlock, removeBlock}) {

const uploadImage =
async (e) => {

  const file =
    e.target.files[0];

  if (!file) return;

  const formData =
    new FormData();

  formData.append(
    "file",
    file
  );

  try {

    const res =
      await API.post(

        "/upload",

        formData,

        {

          headers: {

            "Content-Type":
            "multipart/form-data"

          }

        }

      );

    updateBlock(

      block.id,

      "url",

      res.data.url

    );

  }

  catch(error) {

    console.log(error);

  }

};

  return (

    <div className="popup-block">

    <input type="file" accept="image/*" onChange={uploadImage}/>

{block.url && (
  <img src={block.url} alt=""style={{ width: "100%", marginTop: "10px" }} />

)}

      <input
        type="number"
        placeholder="Largeur (%)"
        value={block.width || 100}
        onChange={(e)=>
          updateBlock(
            block.id,
            "width",
            e.target.value
          )
        }
      />

      <button
        className="remove-block-btn"
        onClick={() =>
          removeBlock(block.id)
        }
      >
        ❌ Supprimer
      </button>

    </div>

  );

}

export default PopupImageBlock;